import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { portalApi } from '../services/api'
import { useAuth } from '../context/AuthContext'
import { useLanguage } from '../context/LanguageContext'

export default function AuthCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { login: setAuth } = useAuth()
  const { t } = useLanguage()

  useEffect(() => {
    const token = params.get('token')
    const error = params.get('error')
    const isNew = params.get('new') === '1'

    if (error) {
      navigate('/login?error=' + error)
      return
    }

    if (!token) {
      navigate('/login?error=no_token')
      return
    }

    // Store the token briefly so the /me call can read it
    localStorage.setItem('portal_token', token)

    // Fetch the full user profile so we have name, Courses_ID, etc.
    portalApi.get('/auth/me')
      .then(({ data }) => {
        setAuth(data.user, token)
        // Honor ?returnTo= for SSO handoffs from Tournament-Web (so a click on
        // "Stay & Play" header in Tournament-Web that's deep-linked into a
        // setup step lands the user there directly, not on the dashboard).
        const returnTo = params.get('returnTo')
        const safe = returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/portal'
        navigate(safe)
      })
      .catch(() => {
        navigate('/login?error=profile_failed')
      })
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, var(--brand-50) 0%, #fff 50%, var(--brand-100) 100%)',
    }}>
      <div style={{ textAlign: 'center' }}>
        <img src="/integolf-logo.svg" alt="InteGolf" style={{ height: 44, marginBottom: 20 }} />
        <div style={{ fontSize: 16, color: 'var(--text-muted)' }}>{t('sp_signing_you_in', 'Signing you in...')}</div>
      </div>
    </div>
  )
}
